import { msg } from '@lingui/core/macro';
import { appFeature } from 'modules/organizer/domain/interfaces/available-feature';
import type { MessageDescriptor } from 'shared/i18n';

/** Подписи фич тарифа (`AppFeature` в GraphQL). */
export const APP_FEATURE_LABELS: Record<appFeature, MessageDescriptor> = {
  MEDIA_MANAGER: msg`Медиа менеджер`,
  ACTIVE_CHAMPIONSHIPS: msg`Активные турниры`,
  JOYSTICK: msg`Джойстик`,
  OBS_INTEGRATION: msg`Интеграция OBS`,
  TOURNAMENT_ANALYTICS: msg`Аналитика`,
  AI_CHAT_ASSISTANT: msg`ИИ-ассистент`,
};
